<footer class="patient-footer">
    <p>Powered By Appoint360</p>
</footer>

